export default __webpack_public_path__ + "static/bg-181a4735e8d42148e8e2b39e9246b4b1.png";